import React, { useEffect, useState, useRef } from "react";
import classes from "./LandingContainerMobile.module.css";
import Navigation from "./Navigation/Navigation"; // the navigation buttons component


const LandingContainerMobile = (props) => {
  const container = useRef(null);

  // these states manage the typing animation
  const [quote, setQuote] = useState("");
  const [cursor, setCursor] = useState("l");
  const [isCursorVisible, SetIsCursorVisible] = useState(false);

  useEffect(() => {
    setTimeout(type, 1700);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // variables manage the typing animation
  var i = 0;
  var txt = "TURNING DISABLITY INTO ABILITY"; // quote to type
  var speed = 50; //speed in ms of typing (increase to slow the typing animation)

  //typing animation function
  const type = () => {
    //repeats until the whole message is typed
    if (i <= txt.length) {
      SetIsCursorVisible(true);
      setQuote(txt.substring(0, i));
      i++;
      setTimeout(type, speed);
    } else {
      // refreshes the cursor to appear and dissappear
      var j = 0;
      setInterval(() => {
        if (j > 10) {
          setCursor("");
          return;
        } else if (j % 2 === 0) {
          j++;
          setCursor("l");
        } else {
          j++;
          setCursor("");
        }
      }, 600);
    }
  };

  return (
    <div className={classes.container} ref={container}>
      {/* the container of the whole landing div */}
      {/* the diagonal white background */}
      <div className={classes.white}>
          {/* header (Logo and NavBar) */}
          <div className={classes.header}>
            {/* Logo */}
            {/* <img src={logo} alt="logo" className={classes.logo} /> */}
            {/* NavBar */}
            <Navigation />
          </div>
          {/* div that include the typing animation */}
          <div className={classes.body}>
            <div className={classes.quote}>
              {quote}
              <span className={classes.cursor}>
                {isCursorVisible && cursor}
              </span>
            </div>
          </div>
        </div>
    </div>
  );
};
export default LandingContainerMobile;
